// On-time rate for milestones. Distinct from calculateOnTimeRate (which models
// meeting cancellation and waives no-shows from the denominator) because a
// milestone that is past due AND undelivered must count as not-on-time, not
// as "excluded from sample". Future-due undelivered milestones are not yet
// measurable and are excluded.

export interface MilestoneOnTimeInput {
  plannedDate?: string | null;
  deliveredAt?: string | null;
}

export interface MilestoneOnTimeResult {
  pct: number | null;
  sampleSize: number;
  numerator: number;
}

const isSet = (v: string | null | undefined): v is string =>
  typeof v === "string" && v.length > 0;

export function calculateMilestonesOnTime(
  milestones: ReadonlyArray<MilestoneOnTimeInput>,
  today: string,
): MilestoneOnTimeResult {
  let sampleSize = 0;
  let numerator = 0;
  for (const m of milestones) {
    if (!isSet(m.plannedDate)) continue;
    if (isSet(m.deliveredAt)) {
      sampleSize += 1;
      if (m.deliveredAt <= m.plannedDate) numerator += 1;
    } else if (m.plannedDate < today) {
      sampleSize += 1;
    }
  }
  if (sampleSize === 0) {
    return { pct: null, sampleSize: 0, numerator: 0 };
  }
  return {
    pct: Math.round((numerator / sampleSize) * 100),
    sampleSize,
    numerator,
  };
}
